export default __webpack_public_path__ + "static/media/recruitment-layer-2.3eccc348.png";